<template>
  <div class="custom-single-checkbox">
    <div
      v-if="title"
      class="col-12 my-0 px-0 title-container d-flex align-items-center"
    >
      <p class="px-4 py-2 m-0">
        {{ title }}
      </p>
    </div>
    <div :id="id" class="d-flex  cursor-pointer" @click="updateValue">
      <div
        class="checkbox-container d-flex align-items-center"
        :class="{
          'white-box': !checked && !error,
          'red-box': error,
          'green-box': checked,
          'has-title': title,
        }"
      >
        <div class="input fa" />
      </div>
      <div
        class="checkbox-word-container d-flex align-items-center flex-fill"
        :class="{
          'white-box': !checked && !error,
          'red-box': error,
          'green-box': checked,
          'has-title': title,
        }"
      >
        <p class="px-4 py-2 m-0" v-html="optionText" />
      </div>
    </div>
    <Error v-if="error" variant="no-border" :message="customErrorMsg" />
  </div>
</template>

<script>
import Error from '@/components/common/Error';
export default {
  name: 'CustomCheckboxSingleOption',
  meta: {
    description:
      'Componente de opción única, con casilla personalizada de verificación',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  methods: {
    updateValue() {
      if (!this.disabled) {
        this.checked = this.checked == true ? undefined : true;
        this.$emit('input', this.checked);
      }
    },
  },
  data() {
    return {
      checked: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.checked = newValue;
    },
  },
  props: {
    id: {
      type: String,
      default: 'chkSingleOption',
      meta: {
        description: 'Id del checkbox de accion',
        example: 'chkSingleOption',
      },
    },
    value: {
      type: Boolean,
      meta: {
        description: 'Parámetro de entrada en el textarea',
        example: 'true',
      },
    },
    optionText: {
      type: String,
      required: true,
      meta: {
        description: 'Propiedad para opciones de texto',
        example: 'Texto requerido',
      },
    },
    title: {
      type: String,
      default: '',
      meta: {
        description: 'Título en el CustomCheckboxSingleOption',
        example: 'Texto requerido',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      },
    },
  },
};
</script>

<style scoped>
.title-container {
  border-radius: 5px 5px 0 0;
  border: 1px solid #e2e2e2;
  border-bottom: none;
  background-color: white;
  min-height: 74px;
  margin: 24px auto;
}
.checkbox-container {
  border-radius: 5px 0 0 5px;
  min-height: 66px;
  width: 96px;
}
.checkbox-container.has-title {
  border-top-left-radius: 0;
}
.checkbox-container .input {
  height: 26px;
  width: 26px;
  margin: 19px 34px;
  border-radius: 4px;
}
.checkbox-word-container {
  border-radius: 0 5px 5px 0;
}
.checkbox-word-container.has-title {
  border-top-right-radius: 0;
}
.checkbox-word-container p {
  text-align: left;
  letter-spacing: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin: auto 0;
}
.white-box {
  background-color: white;
  border: 1px solid #e2e2e2;
}
.white-box.has-title {
  background-color: #f2f2f2;
}
.white-box .input {
  border: 2px solid #c9c9c9;
  background-color: #f2f2f2;
}

.red-box {
  border: 1px solid #c9545e;
  background-color: #ffebeb;
}
.red-box .input {
  background-color: #ffebeb;
  border: 2px solid #c9545e;
}
.green-box {
  background-color: #2db782;
  color: white;
  border: 1px solid #e2e2e2;
}
.green-box .input {
  background-color: white;
  color: #2db782;
  border: 2px solid #e2e2e2;
}
.green-box .input::after {
  content: '\f00c';
  color: #2db782;
  font-size: 20px;
}
</style>
